import { render, staticRenderFns } from "./ModalVideo.vue?vue&type=template&id=3603dc86&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603dc86",
  null
  
)

export default component.exports